module.exports = "footer {\n  padding-top: 3%;\n  padding-bottom: 3%;\n  background-color: #f5f5f5;\n  text-align: center;\n}\n"